export class NouveauMembreDto {
	loginNouveauMembre: string;
	forcerChangementEquipe: boolean;

	constructor(loginNouveauMembre: string, forcerChangementEquipe: boolean) {
		this.loginNouveauMembre = loginNouveauMembre;
		this.forcerChangementEquipe = forcerChangementEquipe;
	}
}
